<template lang="html">
  <div>
    <div v-if="is_finish" class="time-line" v-for="i in list" :key="i.id">
      <p class="title" v-if="i.display_title == '1'">{{i.title}}</p>
      <p v-html="i.summary"></p>
      <div class="line" :class="{'line-format':i.time_format == '1' || i.time_format == '2' || i.time_format == '3', 'line-no':i.display_title == '0' && (i.summary == '' || i.summary == null)}">
        <!-- 0 年1 年月2 年月日3 年月日分时秒 -->
        <!-- 年 -->
        <ul class="time-format0" v-if="i.time_format == '0'">
          <li v-for="j in deal_all['list_index'+i.id]['list']" :key="j[0]">
            <div class="time">{{j[0]}}</div>
            <div class="content" v-for="m in j[1]" :key="m.id">
              <p v-html="m.title"></p>
              <p v-html="m.content_unsigned" v-if="i.display_topic_content == '1'"></p>
            </div>
          </li>
        </ul>
        <!-- 年月， 年月日 -->
        <div v-if="i.time_format == '1' || i.time_format == '2'">
          <ul class="time-format12" v-for="j in deal_all['list_index'+i.id]['list']">
            <li class="fa-li">
              <div class="time fa-time">{{j[0]}}</div>
            </li>
            <li v-for="m in j[1]" :key="m[0]">
              <div class="time">{{m[0]}}</div>
              <div class="content" v-for="n in m[1]" :key="n.id">
                <p v-html="n.title"></p>
                <p v-html="n.content_unsigned" v-if="i.display_topic_content == '1'"></p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 年月日分时秒 -->
        <div v-if="i.time_format == '3'">
          <ul class="time-format3" v-for="j in deal_all['list_index'+i.id]['list']">
            <li class="fa-li">
              <div class="time fa-time">{{j[0]}}</div>
            </li>
            <li v-for="(m, index) in j[1]" :key="m[0]">
              <div class="time">
                {{dealTime(m[0], 0)}}
              </div>
              <div class="index">
                {{dealTime(m[0], 1)}}
              </div>
              <div class="time-content" v-for="(n, index) in m[1]" :key="n.id">
                <div class="index other-index" v-if="index != 0">
                  {{dealTime(m[0], 1)}}
                </div>
                <div class="content">
                  <p v-html="n.title"></p>
                  <p v-html="n.content_unsigned" v-if="i.display_topic_content == '1'"></p>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="share">
          <span>分享至</span>
          <div @click="goShare(i.id)">
            <i class="iconfont">&#xe641;</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filter from 'js/filter'
export default {
  data() {
    return {
      is_finish: false,
      deal_all: {}
    }
  },
  props: ['list'],
  methods: {
    dealList() {
      for(let i of this.list) {
        let map = new Map()
        let temp = []
        this.deal_all['list_index'+i.id] = {}
        this.deal_all['list_index'+i.id]['time_format'] = i.time_format
        this.deal_all['list_index'+i.id]['list'] = []
        if(i.time_format == 0) {
          for(let j of i.line_content) {
            let year = filter.time_moment(j.oldest_news_publish_time, 'YYYY') + '年'
            if (map.has(year)) {
              map.get(year).push(j)
            } else {
              map.set(year, [j])
            }
          }
          this.deal_all['list_index'+i.id]['list'] = [...map]
        } else {
          for(let j of i.line_content) {
            let year = filter.time_moment(j.oldest_news_publish_time, 'YYYY') + '年'
            let month
            if (i.time_format == '1') {
              month = filter.time_moment(j.oldest_news_publish_time, 'MM') + '月'
            } else if(i.time_format == '2'){
              month = filter.time_moment(j.oldest_news_publish_time, 'MM-DD')
            } else {
              month = filter.time_moment(j.oldest_news_publish_time, 'MM-DD') + ' ' + filter.time_moment(j.oldest_news_publish_time, 'HH:mm')
            }
            if (map.has(year)) { // 先给年分类
              if (map.get(year).has(month)) {
                map.get(year).get(month).push(j)
              } else {
                map.get(year).set(month, [j])
              }
            } else {
              map.set(year, new Map())
              map.get(year).set(month, [j])
            }
          }
          let list = [...map]
          for (let m of list) {
            m[1] = [...m[1]]
          }
          // list的数据机构(三维数组)
          // ['2019',map]
          // ['2019',['12月',[item, item]]]
          this.deal_all['list_index'+i.id]['list'] = list
        }

      }
      this.is_finish = true
    },
    dealTime(time, index) {
      return time.split(' ')[index]
    },
    goShare(time_line_id) {
      this.$router.push({name: 'MShareTimeLine', query: {theme_uid: this.$route.params.uid || this.$route.query.theme_uid, time_line_id: time_line_id}})
    }
  },
  mounted() {
    this.dealList()
  }
}
</script>

<style lang="stylus" scoped>
.time-line
  margin-top: .4rem;
  padding: .4rem .4rem .88rem .4rem;
  background: #F9F9F9;
  >p+p
    margin-top: .14rem;
  >p
    font-size: .32rem;
    line-height: .48rem;
    color: #333;
  >p.title
    font-weight: 600;
  .line
    margin-top: .28rem;
    padding: .36rem 0 0 0;
    border-top: .02rem solid #E9E9E9;
    .time-format0,.time-format12,.time-format3
    //   padding-bottom: .4rem;
      li
        position: relative;
        border-left: .02rem dashed #E5E5E5;
        margin-left: .5rem;
        padding-left: .68rem;
        padding-bottom: .44rem;
        &.fa-li
          padding-bottom: .6rem;
        .time
          background-image: linear-gradient(90deg, #FFA337 6%, #FA5A00 100%);
          border-radius: .2rem;
          color: #fff;
          font-size: .24rem;
          width: 1rem;
          height: .4rem;
          text-align: center;
          line-height: .4rem
          position: absolute;
          left: -.5rem;
          top: 0;
          &.fa-time
            background:#F9F9F9;
            color: #FA5A00;
            height: .44rem;
            line-height: .44rem;
            font-weight: 600;
        .index
          background:#F9F9F9;
          width: 1rem;
          height: .48rem;
          line-height: .48rem;
          text-align: center;
          position: absolute;
          left: -.5rem;
          top: .4rem;
          color: #999999;
          font-size: .24rem;
          &.other-index
            top: -.06rem;
            left: -1.18rem;
            height: .62rem;
            line-height: .62rem;
        .content
          >p:nth-child(1)
            font-size: .32rem;
            color: #333333;
            line-height: .48rem;
            min-height: .68rem;
          >p:nth-child(2)
            font-size: .28rem;
            color: #666666;
            line-height: .48rem;
          >p+p
            margin-top: .08rem;
        .content+.content
          margin-top: .4rem;
        .time-content
          position: relative;
        .time-content + .time-content
          margin-top: .4rem;
    // .time-format0
    //   li:last-child
    //     border-left: none;
    //     padding-bottom: 0;
    .time-format12,.time-format3
      padding-bottom: 0;
    // .time-format12:last-child,.time-format3:last-child
    //   padding-bottom: .4rem;
    &.line-format
      padding-top: .2rem;
      // ul:last-child
      //   li:last-child
      //     border-left: none;
      //     padding-bottom: 0
    &.line-no
      padding-top: 0;
      margin-top:0;
      border-top:none
    .share
      float: right;
      display: flex;
      align-items: center;
      span
        font-size: .24rem;
        color: #999999;
      div
        width: .68rem;
        height: .68rem;
        text-align: center;
        line-height: .68rem;
        margin-left: .2rem;
        display: inline-block;
        background: #fff;
        border-radius: 50%;
        border: 1px #eee solid;
        i
          color: rgb(46, 198, 107);
          font-size: .40rem;
</style>
